// FundTooltip.ts
import { Chart as ChartJS, TooltipModel } from "chart.js";
import { formatHandlerCode } from "../../utils/namesFormater";
import { formatFundFieldLabel } from "../../utils/fundsFormatter";


interface FundTooltipProps {
  chart: ChartJS;
  tooltip: TooltipModel<any>;
  funds: any[];
  selectedField: string;
  positionOutsideCanvas?: boolean;
  positionDirection?: "left" | "right";
}

function wrapNumber(value: string | number): string {
  return `<span style="direction: ltr; unicode-bidi: embed;">${value}</span>`;
}
function wrapStyledNumber(value: string | number, backgroundColor = "transparent"): string {
  return `<span style="direction: ltr; unicode-bidi: embed;">
      <span style="color:#1976d2;font-size:1rem;font-weight:700;background:${backgroundColor}">${value}</span>
  </span>`;
}

export function renderFundTooltip({ chart, tooltip, funds, selectedField, positionOutsideCanvas, positionDirection }: FundTooltipProps) {
  let tooltipEl = document.getElementById("chartjs-custom-tooltip");


  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chartjs-custom-tooltip";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.zIndex = "1000";
    document.body.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    return;
  }

  const canvasRect = chart.canvas.getBoundingClientRect();
  const positionOutsideCanvasFinal = positionOutsideCanvas ?? false;
  const positionDirectionFinal = positionDirection || "right";

  tooltipEl.style.left = positionOutsideCanvasFinal
    ? `${positionDirectionFinal === 'left' ? canvasRect.left - 340 : canvasRect.right + 16}px`
    : `${canvasRect.left + 16}px`;

  tooltipEl.style.top = `${canvasRect.top + 16}px`;
  const dataPointsSorted = [...(tooltip.dataPoints || [])].sort((a, b) => {
    const aValue = parseFloat(a.formattedValue);
    const bValue = parseFloat(b.formattedValue);
    return bValue - aValue;
  });
  
  const maxValue = parseFloat(dataPointsSorted[0]?.formattedValue ?? "0");
  const minValue = parseFloat(dataPointsSorted[dataPointsSorted.length - 1]?.formattedValue ?? "0");
  // const activeElements = chart.tooltip?.getActiveElements?.();
  // const activeFundId = activeElements?.length
  // ? (chart.data.datasets[activeElements[0].datasetIndex] as any)?.fundId
  // : undefined;

  const lines = (tooltip.dataPoints || []).map((dp: any) => {
    const fundId = dp.dataset.fundId;
    const value = dp.formattedValue;
    const fund = funds?.find((f) => f.fund_id === fundId);
    const fundName = fund?.fund_name || dp.dataset.label || `קרן ${fundId}`;
    const classification = fund?.fund_classification || "";
    const specialization = [fund?.specialization, fund?.sub_specialization].filter(Boolean).join(", ");
    const handlerCode = fund?.managing_corporation_legal_id
      ? formatHandlerCode(fund.managing_corporation_legal_id.toString())
      : "";
    const baseColor = dp.dataset.borderColor || "#888";
    const isHighlighted = false;// fundId === activeFundId;
    const monthlyYieldLine =''
    //  selectedField !== "monthly_yield" && fund?.monthly_yield !== undefined
    //   ? `<div style='opacity: 0.6;'>תשואה חודשית: %${wrapNumber(fund.monthly_yield.toFixed(2))}</div>`
    //   : "";
    const valueNumeric = parseFloat(value);
    const backgroundColor =
      valueNumeric === maxValue
        ? 'rgba(0, 200, 0, 0.3)'
        : valueNumeric === minValue
        ? 'rgba(255, 0, 0, 0.3)'
        : 'transparent';

        const valueLabel =`${formatFundFieldLabel(selectedField as any).label}: ${wrapStyledNumber(value, backgroundColor)}`;

        const containerStyle = isHighlighted ? "background: rgba(25,118,210,0.12); border-radius: 6px; padding: 4px;" : "";
    return `<div style="display: flex; align-items: center; margin-bottom: 6px; ${containerStyle}">
      <div style="width: 12px; height: 12px; background: ${baseColor}; margin-left: 6px; border-radius: 2px;"></div>
      <div style="font-size: 13px;">
        <div><strong>${fundName}</strong> (${fundId}): <span style="color:#1976d2;font-size:1rem;font-weight:700;">${valueLabel}</span></div>
      <!--  ${classification ? `<div style='opacity: 0.8;'>${classification}</div>` : ""}
        ${specialization ? `<div style='opacity: 0.7;'>${specialization}</div>` : ""} !-->
     <!--   ${handlerCode ? `<div style='opacity: 0.6;'>${handlerCode}</div>` : ""}!-->
        ${monthlyYieldLine}
      </div>
    </div>`;
  });

  const header = `<div style="font-size: 16px; font-weight: bold; margin-bottom: 8px;">
    נתוני חודש: ${tooltip.title?.[0] || ""}
  </div>`;

  tooltipEl.innerHTML = `<div dir="rtl" style="background: white; border: 1px solid gray; padding: 10px 14px; border-radius: 8px; max-width: 340px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
    ${header}
    ${lines.join("")}
  </div>`;

  tooltipEl.style.opacity = "1";
}

export const verticalLinePlugin = {
  id: 'verticalLinePlugin',
  afterDatasetsDraw: (chart: ChartJS) => {
    const activeElements = chart.tooltip?.getActiveElements?.();
    if (activeElements && activeElements.length > 0) {
      const ctx = chart.ctx;
      const x = activeElements[0].element.x;
      const topY = chart.chartArea.top;
      const bottomY = chart.chartArea.bottom;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#999';
      ctx.stroke();
      ctx.restore();
    }
  }
};
